import { createStore } from 'satcheljs';
export default createStore('generalOptions', {
    supportedCultures: [],
    supportedShortDateFormats: [],
    supportedShortTimeFormats: [],
    supportedTimeZones: [],
    selectedLocale: null,
    shouldRenameDefaultFolders: true,
    selectedDateFormat: null,
    selectedTimeFormat: null,
    selectedTimeZone: null,
    hasUserChangedLanguage: false,
});
//# sourceMappingURL=store.js.map